class ImageUtils {
  static async decryptImage(imgSrc: string, sdkContent: any) {
    try {
      if (!imgSrc) {
        return imgSrc;
      }
      // 下载加密图片（使用 XHR，确保携带 Cookie 且拿到二进制数据）
      const { buffer: cipherBuffer, contentType }: any = await new Promise((resolve, reject) => {
        try {
          const xhr: any = new XMLHttpRequest();
          xhr.open("GET", imgSrc, true);
          xhr.responseType = "arraybuffer";
          xhr.crossDomain = true;
          xhr.onload = () => {
            if (xhr.status >= 200 && xhr.status < 300) {
              resolve({
                buffer: xhr.response,
                contentType: xhr.getResponseHeader("Content-Type") || "image/png",
                crossDomain: true,
              });
            } else {
              reject(new Error(`HTTP ${xhr.status}`));
            }
          };
          xhr.onerror = () => reject(new Error("Network error"));
          xhr.ontimeout = () => reject(new Error("Request timeout"));
          xhr.send();
        } catch (e) {
          reject(e);
        }
      });
      // 通过 SDK 解密
      const plainBytes = sdkContent.getToolKitService().decryptImageData(new Int8Array(cipherBuffer));
      // 组装解密后的图片 Blob，并写入缓存
      const mimeType = contentType || "image/png";
      const decryptedBlob = new Blob([plainBytes.buffer], { type: mimeType });
    //   await cacheBlob(imgSrc, decryptedBlob);
      // 返回可用的对象 URL
      return URL.createObjectURL(decryptedBlob);
    } catch (exception: any) {
      console.error(exception);
      return "";
    }
  }
}

export default ImageUtils;
